import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const MainBannerSwiperType2 = styled.div`
  .swiper-slide {
    position: relative;
    overflow: hidden;

    &.swiper-slide-active {
      .textBox {
        .text {
          opacity: 1;
          transform: translate3d(0, 0, 0);
        }
      }
    }

    &:not(.swiper-slide-active) {
      .textBox {
        .text {
          opacity: 0;
          transform: translate3d(0, 40px, 0);
        }
      }
    }
  }

  .swiper-pagination-fraction03 {
    display: inline-flex;
    bottom: 15px;
    right: 15px;
    color: #fff;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .swiper-slide {
      &:not(.swiper-slide-active) {
        .textBox {
          .text {
            transform: translate3d(0, 40px, 0);
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .swiper {
      padding: 0;
      max-width: var(--pc-width);
    }

    .swiper-wrapper {
      height: auto;
      padding: 20px 0 0;
    }

    .swiper-slide {
      width: auto;
      max-width: var(--pc-width);
      ${mixin.flex({ justify: 'space-between' })};
      column-gap: 18px;

      .main-banner-item-type2 {
        width: 430px;
        height: 460px;
        overflow: hidden;
      }

      .thumbnail:after {
        background-color: rgba(0, 0, 0, 0.4) !important;
      }

      .textBox:after {
        opacity: 0 !important;
      }

      .textBox .text {
        opacity: 0;
        transform: none !important;
        transition-duration: 0.1s;
      }

      &.swiper-slide-active {
        .thumbnail:after {
          background-color: rgba(0, 0, 0, 0.03) !important;
        }

        .textBox:after {
          opacity: 1 !important;
        }

        .textBox .text {
          opacity: 1;
        }
      }
    }

    .swiper-pagination-progressbar01 {
      left: 50%;
      margin: 16px 0 0 -662px;

      & + .swiper-navigation-bottom01 {
        right: 50%;
        margin-right: -626px;
      }
    }

    .items-swiper:has(.swiper-pagination-progressbar01) {
      padding-bottom: 13px;

      .swiper-pagination-progressbar01 + .swiper-navigation-bottom01 {
        bottom: 13px;
      }
    }
  }
`;
